import React, { useEffect, useMemo } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import { noop } from 'ui-components/default-props/noop';
import { useMaxZ } from 'ui-components/hooks/services/use-max-z';

import { NotificationCloseButton } from '../notification/notification-close-button';
import { NotificationService } from '../../services/notification-service';
import style from './mobile-notification.module.less';
import { MobileNotificationContent } from './mobile-notifcation-content';

export const MobileToastNotification = ({
  notificationType,
  content,
  id,
  onButtonClick = noop,
  onClick,
  onClose,
  trackNotificationClose = noop,
}) => {
  const zIndex = useMaxZ();
  const zIndexStyle = useMemo(() => ({ zIndex }), [zIndex]);

  useEffect(() => {
    const removeMobileNotification = (event) => {
      if (!event.target.className.includes('mobile-notification')) {
        NotificationService.removeNotification(id);
      }
    };
    window.addEventListener('touchstart', removeMobileNotification);
    return () => {
      window.removeEventListener('touchstart', removeMobileNotification);
    };
  }, [id]);

  const buttonClickAndDismissNotification = () => {
    NotificationService.removeNotification(id);
    onButtonClick();
  };

  return (
    <div className={classnames(style['mobile-notification'], style[notificationType])} onClick={onClick} style={zIndexStyle}>
      <MobileNotificationContent content={content(buttonClickAndDismissNotification)} />
      <NotificationCloseButton
        id={id}
        notificationType={notificationType}
        onClose={onClose}
        trackNotificationClose={trackNotificationClose}
        withMobileStyling
      />
    </div>
  );
};

MobileToastNotification.propTypes = {
  notificationType: PropTypes.oneOf(['info', 'success', 'error']).isRequired,
  content: PropTypes.func.isRequired,
  onButtonClick: PropTypes.func,
  onClick: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
  trackNotificationClose: PropTypes.func,
};
